
import Vue from 'vue'
import GoBack from '@/components/navigation/GoBack.vue'
import RButton from '@/components/forms/RButton.vue'
import { WorkstationDocument } from '@/api/types/workstation'
import DriveDeleteModal from '@/components/modals/DriveDelete.vue'
import { RequestInfo } from '@/store/types/root'
import EditProfileSaveCancel from '@/components/account/EditProfileSaveCancel.vue'
import EditProfileChangeButton from '@/components/account/EditProfileChangeButton.vue'

import { mapGetters, mapActions } from 'vuex'

import RInput from '@/components/forms/RInput.vue'
import RCard from '@/components/platform/RCard.vue'

type BasicInfoData = {
  workstationName: string
  editMode: boolean
}

export default Vue.extend({
  name: 'Settings',
  components: {
    GoBack,
    RButton,
    DriveDeleteModal,
    RInput,
    RCard,
    EditProfileSaveCancel,
    EditProfileChangeButton,
  },
  data(): BasicInfoData {
    return {
      workstationName: '',
      editMode: false,
    }
  },
  created() {
    this.workstationName = this.workstation.name
  },
  computed: {
    uuid(): string {
      return this.$router.currentRoute.params.pathMatch.slice(1)
    },
    workstation(): WorkstationDocument {
      return this.info(this.uuid)
    },
    deleteRequest(): RequestInfo | undefined {
      return this.requestInfo(this.uuid)?.deleteWorkstation
    },
    changeWorkstationNameRequest(): RequestInfo | undefined {
      return this.requestInfo(this.uuid)?.changeWorkstationName
    },
    isDeletionRequestPending(): boolean {
      return this.deleteRequest ? (this.deleteRequest as RequestInfo).pending : false
    },
    isChangeWorkstationNameRequestPending(): boolean {
      return this.changeWorkstationNameRequest
        ? (this.changeWorkstationNameRequest as RequestInfo).pending
        : false
    },
    allowWorkstationDelete(): boolean {
      return this.selectedPlan.codename.includes('studio')
    },
    ...mapGetters({
      info: 'workstation/info',
      requestInfo: 'workstation/requestInfo',
      selectedPlan: 'user/selectedTier',
    }),
    labelBackground(): string {
      return this.editMode ? 'var(--bgTertiary)' : 'var(--bgSecondary)'
    },
  },
  methods: {
    ...mapActions({
      delete: 'workstation/delete',
      changeWorkstationName: 'workstation/changeWorkstationName',
    }),
    onDeleteClick(): void {
      this.$modal.show('confirm-deletion')
    },
    onCancel(): void {
      this.$modal.hide('confirm-deletion')
    },
    onConfirmDeletion(): void {
      // BUG: TS throws that the mapped action is not defined on the instance
      // this.delete({ uuid: this.uuid })
      this.$store.dispatch('workstation/delete', { uuid: this.uuid })
    },
    saveChanges(): void {
      const { workstationName, uuid } = this
      this.editMode = false
      if (this.workstation.name === workstationName) return
      this.changeWorkstationName({ uuid, name: workstationName })
    },
    cancelChanges() {
      this.workstationName = this.workstation.name
      this.editMode = false
    },
    enableEditMode() {
      this.editMode = true
    },
  },
})
